/**
 * Verify feature flag (dashboard) — runtime wrapper.
 *
 * Production availability is controlled by VITE_ENABLE_VERIFY at build time.
 * Enable alongside the server's ENABLE_FIX_VERIFICATION rollout switch; the
 * two surfaces read separate settings and must be verified together.
 *
 * This module reads `import.meta.env`, so it must NOT be imported by jest tests
 * (the dashboard runs jest in CJS, where `import.meta` is a syntax error — see
 * computeVerifyEnabled.ts for the unit-tested pure logic). Components import
 * `isVerifyEnabled` from here; tests pass the resolved boolean in instead.
 */
import { computeVerifyEnabled, type VerifyFlagEnv } from './computeVerifyEnabled';

/** Runtime gate reading Vite's build-time env. */
export function isVerifyEnabled(): boolean {
  return computeVerifyEnabled((import.meta as { env?: VerifyFlagEnv }).env);
}
